import { render, staticRenderFns } from "./titulo-reactivo.vue?vue&type=template&id=435872dc&"
import script from "./titulo-reactivo.vue?vue&type=script&lang=ts&"
export * from "./titulo-reactivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports